{
  "name": "npm-check-updates",
  "version": "22.2.9",
  "author": "Tomas Junnonen <tomas1@gmail.com>",
  "license": "Apache-2.0",
  "contributors": [
    "Raine Revere (https://github.com/raineorshine)",
    "Imamuzzaki Abu Salam <imamuzzaki@gmail.com>"
  ],
  "description": "Find newer versions of dependencies than what your package.json allows",
  "keywords": [
    "dependencies",
    "npm",
    "package.json",
    "update",
    "upgrade",
    "versions"
  ],
  "engines": {
    "node": "^20.19.0 || ^22.12.0 || >=24.0.0",
    "npm": ">=10.0.0"
  },
  "type": "module",
  "main": "build/index.cjs",
  "module": "build/index.js",
  "types": "build/index.d.ts",
  "bin": {
    "npm-check-updates": "build/cli.js",
    "ncu": "build/cli.js"
  },
  "exports": {
    ".": {
      "types": "./build/index.d.ts",
      "import": "./build/index.js",
      "require": "./build/index.cjs"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "vite build",
    "build:options": "tsx scripts/build-options.ts",
    "build:analyze": "cross-env ANALYZER=true vite build",
    "lint": "cross-env FORCE_COLOR=1 npm-run-all --parallel --continue-on-error --aggregate-output lint:*",
    "lint:lockfile": "lockfile-lint",
    "lint:types": "tsc --noEmit",
    "lint:markdown": "markdownlint-cli2 \"**/*.md\" \"!**/node_modules/**/*.md\" \"!build/**/*.md\"",
    "lint:src": "eslint --cache --cache-location node_modules/.cache/.eslintcache --report-unused-disable-directives",
    "prepare": "git config core.hooksPath .hooks || exit 0",
    "prepublishOnly": "npm run build",
    "prettier": "prettier . --check",
    "prettier:fix": "prettier . --write",
    "test": "tsc --noEmit && npm run test:unit && npm run test:e2e",
    "test:bun": "mocha test/bun",
    "test:unit": "mocha test --ignore \"test/bun/*\"",
    "test:e2e": "bash ./test/e2e.sh",
    "ncu": "node build/cli.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/raineorshine/npm-check-updates.git"
  },
  "homepage": "https://github.com/raineorshine/npm-check-updates",
  "bugs": {
    "url": "https://github.com/raineorshine/npm-check-updates/issues"
  },
  "overrides": {
    "typescript": "$typescript",
    "eslint": "$eslint",
    "eslint-config-standard": {
      "eslint-plugin-n": "$eslint-plugin-n",
      "eslint-plugin-promise": "$eslint-plugin-promise"
    },
    "mocha": {
      "diff": "^8.0.3",
      "serialize-javascript": "^7.0.3"
    },
    "@cypress/request": {
      "uuid": "^14.0.0"
    }
  },
  "devDependencies": {
    "@eslint/compat": "^2.1.0",
    "@eslint/js": "^10.0.1",
    "@microsoft/api-extractor": "^7.58.9",
    "@streamparser/json": "^0.0.22",
    "@trivago/prettier-plugin-sort-imports": "^6.0.2",
    "@types/bun": "^1.3.14",
    "@types/chai": "^5.2.3",
    "@types/chai-as-promised": "^8.0.2",
    "@types/chai-string": "^1.4.5",
    "@types/hosted-git-info": "^3.0.5",
    "@types/ini": "^4.1.1",
    "@types/jsonlines": "^0.1.5",
    "@types/mocha": "^10.0.10",
    "@types/node": "^25.9.4",
    "@types/npm-registry-fetch": "^8.0.9",
    "@types/parse-github-url": "^1.0.3",
    "@types/picomatch": "^4.0.3",
    "@types/progress": "^2.0.7",
    "@types/semver": "^7.7.1",
    "@types/semver-utils": "^1.1.3",
    "@types/sinon": "^21.0.1",
    "@types/update-notifier": "^6.0.8",
    "@typescript-eslint/eslint-plugin": "^8.62.0",
    "@typescript-eslint/parser": "^8.62.0",
    "camelcase": "^9.0.0",
    "chai": "^6.2.2",
    "chai-as-promised": "^8.0.2",
    "chai-string": "^2.0.0",
    "chalk": "^5.6.2",
    "cli-table3": "^0.6.5",
    "commander": "^14.0.3",
    "cross-env": "^10.1.0",
    "eslint": "^10.6.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-config-raine": "^0.5.0",
    "eslint-config-standard": "^17.1.0",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-import-x": "^4.17.0",
    "eslint-plugin-jsdoc": "^62.9.0",
    "eslint-plugin-n": "^18.2.1",
    "eslint-plugin-promise": "^7.3.0",
    "fast-glob": "^3.3.3",
    "fast-memoize": "^2.5.2",
    "find-up": "^8.0.0",
    "fp-and-or": "^1.0.2",
    "globals": "^17.7.0",
    "hosted-git-info": "^9.0.3",
    "ini": "^6.0.0",
    "jsonc-parser": "^3.3.1",
    "jsonlines": "^0.1.1",
    "lilconfig": "^3.1.3",
    "lockfile-lint": "^5.0.0",
    "markdownlint-cli2": "^0.18.0",
    "mocha": "^11.7.6",
    "npm-registry-fetch": "^19.1.1",
    "npm-run-all2": "^8.0.4",
    "p-map": "^7.0.4",
    "parse-github-url": "^1.0.4",
    "picomatch": "^4.0.4",
    "prettier": "^3.8.5",
    "progress": "^2.0.3",
    "prompts-ncu": "^3.0.3",
    "semver": "^7.8.5",
    "semver-utils": "^1.1.4",
    "sinon": "^22.0.0",
    "spawn-please": "^3.0.0",
    "timeago.js": "^4.0.2",
    "ts-json-schema-generator": "2.4.0",
    "tsx": "^4.22.4",
    "typescript": "^6.0.3",
    "unplugin-dts": "^1.0.3",
    "untildify": "^6.0.0",
    "update-notifier": "^7.3.1",
    "valibot": "^1.4.1",
    "verdaccio": "^6.7.4",
    "vite": "^8.1.0",
    "vite-bundle-analyzer": "^1.3.8",
    "yaml": "^2.9.0",
    "yarn": "^1.22.22"
  },
  "files": [
    "build"
  ],
  "allowScripts": {
    "yarn@1.22.22": true,
    "esbuild@0.28.1": true,
    "unrs-resolver@1.11.1": true
  }
}
